import { render, staticRenderFns } from "./tickets.vue?vue&type=template&id=087496ac&"
import script from "./tickets.ts?vue&type=script&lang=ts&"
export * from "./tickets.ts?vue&type=script&lang=ts&"
import style0 from "./tickets.scss?vue&type=style&index=0&lang=scss&_scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports